import React, { useRef, useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  ImageListItem,
  Stack,
  Grid,
} from "@mui/material";
import androidOne from "./assets/android/android_1.png";
import androidThree from "./assets/android/android_3.png";
import androidFour from "./assets/android/android_4.png";
import androidFive from "./assets/android/android_5.png";
import androidSix from "./assets/android/android_6.png";
import androidSeven from "./assets/android/android_7.png";
import androidEight from "./assets/android/android_8.png";

import training from "./assets/android/training.png";

import { Divider } from "@mui/material";

import {
  AndroidTwoTone,
  ChevronLeft,
  ChevronRight,
  FiberManualRecord,
} from "@mui/icons-material";
import Footer from "./footer";

const AndroidTraining = () => {
  const scrollRef = useRef();

  const images = [
    androidThree,
    androidFour,
    androidFive,
    androidSix,
    androidSeven,
    androidEight,
  ];

  const indexRef = useRef(0);
  const [activeIndex, setActiveIndex] = useState(0);

  const scrollToIndex = (index) => {
    const width = scrollRef.current.offsetWidth;
    scrollRef.current.scrollTo({
      left: index * width,
      behavior: "smooth",
    });
    setActiveIndex(index);
  };

  const handleManualScroll = (direction) => {
    const newIndex =
      (indexRef.current + direction + images.length) % images.length;
    indexRef.current = newIndex;
    scrollToIndex(newIndex);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      indexRef.current = (indexRef.current + 1) % images.length;
      scrollToIndex(indexRef.current);
    }, 3000); // every 3 seconds

    return () => clearInterval(interval); // cleanup on unmount
  }, []);

  return (
    <Box>
      <Box maxWidth="100%">
        <Box
          sx={{
            position: "relative",
            minHeight: { xs: "50vh", md: "50vh" },
            backgroundImage: `url(${androidOne})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            px: 2,
            flexDirection: "column",
            textAlign: "center",
            overflow: "hidden",
          }}
        >
          {/* Blurred Overlay */}
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              backdropFilter: "blur(2px)",
              zIndex: 1,
            }}
          />

          {/* Text Content */}
          <Box sx={{ maxWidth: "auto", mb: 4, zIndex: 2 }}>
            <Typography
              variant="h3"
              gutterBottom
              sx={{ color: "white", fontWeight: 700 }}
            >
              Android App Training
            </Typography>
          </Box>
        </Box>
      </Box>

      <Grid
        container
        spacing={4}
        alignItems="top"
        justifyContent="center"
        sx={{ flexWrap: "wrap", mt: 5 }}
      >
        {/* Left: Image */}

        <Grid item sx={{ width: { xs: "100%", md: "40%" } }}>
          <Box
            sx={{
              pl: { xs: 2, md: 0 },
              pr: { xs: 2, md: 0 },
              mb: { xs: 0, md: 2 },
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                color: "orange",
                textAlign: "left",
                pb: { xs: 2, md: 2 },
              }}
            >
              Android App Training
            </Typography>
            <Typography
              variant="body1"
              sx={{
                pb: { xs: 2, md: 2 },
              }}
              paragraph
            >
              An Android mobile app is a software application designed
              specifically to run on devices powered by the Android operating
              system. These apps can be anything from social media platforms and
              e-commerce stores to educational tools and gaming experiences.
              Android apps are typically developed using Java or Kotlin and are
              distributed through the Google Play Store.
            </Typography>

            <Typography
              variant="body1"
              sx={{
                pb: { xs: 2, md: 2 },
              }}
            >
              What makes Android app development attractive is its open-source
              foundation, which allows developers to customize and innovate
              freely. With access to a rich set of APIs, hardware features like
              GPS, camera, and sensors, and integration with Google’s services,
              developers can build feature-rich, interactive, and
              high-performance applications. The flexibility of the platform
              makes it ideal for startups, enterprises, and independent
              developers alike.
            </Typography>

            <Typography variant="body1">
              Android apps are an essential part of today’s digital economy.
              They help businesses increase their reach, improve customer
              engagement, and automate services. As mobile usage continues to
              grow, Android apps are becoming a primary channel for companies to
              connect with users and offer their services. Whether it’s a
              ride-sharing app, an online store, or a fitness tracker, Android
              apps have become a critical component of how we interact with the
              digital world every day.
            </Typography>
          </Box>
        </Grid>

        <Grid item sx={{ width: { xs: "100%", md: "35%" } }}>
          <Box
            flex={1}
            maxHeight="800px"
            overflow="auto"
            borderLeft="1px solid #ccc"
            sx={{ pl: { xs: 0, md: 2 } }}
          >
            <Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{
                  maxWidth: "100%",
                  mx: "auto",
                  overflow: "hidden",
                  mt: { xs: 0, md: 4 },
                }}
              >
                <IconButton onClick={() => handleManualScroll(-1)}>
                  <ChevronLeft />
                </IconButton>

                <Box
                  ref={scrollRef}
                  sx={{
                    width: { xs: "100%", md: 600 },
                    height: { xs: "100%", md: 500 },
                    display: "flex",
                    overflowX: "hidden",
                    scrollSnapType: "x mandatory",
                  }}
                >
                  {images.map((src, index) => (
                    <ImageListItem
                      key={index}
                      sx={{
                        flex: "0 0 100%",
                        scrollSnapAlign: "center",
                      }}
                    >
                      <img
                        src={src}
                        alt={`Slide ${index + 1}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "16px", // Adjust as needed (e.g., 8px, 24px)
                        }}
                        loading="lazy"
                      />
                    </ImageListItem>
                  ))}
                </Box>

                <IconButton onClick={() => handleManualScroll(1)}>
                  <ChevronRight />
                </IconButton>
              </Box>

              {/* Indicators */}
              <Stack
                direction="row"
                justifyContent="center"
                mt={2}
                sx={{ mt: 5 }}
              >
                {images.map((_, index) => (
                  <IconButton
                    key={index}
                    size="small"
                    onClick={() => scrollToIndex(index)}
                  >
                    <FiberManualRecord
                      fontSize="small"
                      color={index === activeIndex ? "primary" : "disabled"}
                    />
                  </IconButton>
                ))}
              </Stack>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Divider sx={{ my: 1, borderColor: "orange", mt: 5 }} />

      <Box sx={{ width: { xs: "100%", md: "80%" }, mx: "auto", mb: 5 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center", // centers horizontally
            px: 2,
            mt: 5,
          }}
        >
          <Box>
            <Typography
              variant="h4"
              sx={{ color: "orange", fontWeight: "bold", mb: 1 }}
            >
              Why should you learn Android?
            </Typography>

            <Typography variant="body1" sx={{ mb: 2 }}>
              Android powers a vast majority of smartphones worldwide, making it
              a highly valuable skill in the tech industry. Learning Android app
              development opens doors to numerous career opportunities,
              freelance projects, and entrepreneurial ventures. With its
              open-source nature and large user base, Android development allows
              you to reach a global audience.
            </Typography>
          </Box>
        </Box>

        {/* Centered small orange line */}
        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />

        {/* Content Block: Image Left, Text Right */}
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{ flexWrap: "wrap", pl: { xs: 2, md: 0 }, pr: { xs: 2, md: 0 } }}
        >
          {/* Left: Image */}
          <Grid item sx={{ width: { xs: "100%", md: "40%" } }}>
            <img
              src={androidThree}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>

          {/* Right: Text */}
          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Why Learn Android App Development from us?
            </Typography>
            <Typography variant="body1">
              We offer industry-relevant Android training led by experienced
              professionals. Our course structure is designed to take you from
              beginner to advanced level with practical assignments, real-time
              project work, and mentorship. We don't just teach; we build
              confidence and job-readiness through hands-on training.
            </Typography>

            <Typography variant="body1">
              What makes Android app development attractive is its open-source
              foundation, which allows developers to customize and innovate
              freely. With access to a rich set of APIs, hardware features like
              GPS, camera, and sensors, and integration with Google’s services,
              developers can build feature-rich, interactive, and
              high-performance applications. The flexibility of the platform
              makes it ideal for startups, enterprises, and independent
              developers alike.
            </Typography>
          </Grid>
        </Grid>

        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{ flexWrap: "wrap", pl: { xs: 2, md: 0 }, pr: { xs: 2, md: 0 } }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Zero Investment Android Training
            </Typography>
            <Typography variant="body1">
              Our zero-investment Android training program is designed to remove
              financial barriers so that anyone with a passion for mobile
              development can start learning without hesitation. Unlike
              traditional courses that demand high upfront fees, our model
              allows you to begin your training journey without paying anything
              initially. This approach ensures that students from all
              backgrounds—especially those with financial constraints—get equal
              opportunities to build a career in tech. The training focuses on
              core concepts of Android development, covering both Java and
              Kotlin, and emphasizes real-world projects to help you build a
              strong portfolio.
            </Typography>

            <Typography variant="body1" sx={{ mt: 1 }}>
              The best part? You only invest in the program once you land a job.
              This outcome-based training structure holds us accountable for
              your success and pushes us to deliver industry-relevant skills and
              personalized mentorship. You’ll receive expert guidance from
              experienced Android developers, access to in-house labs, hands-on
              coding exercises, and regular assessments to track progress. Our
              mission is simple: help you become a job-ready Android developer
              with zero upfront financial risk. Your success is our goal—and we
              only succeed when you do.
            </Typography>
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={androidFive}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
        </Grid>

        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            pb: { xs: 2, md: 0 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}
          <Grid item sx={{ width: { xs: "100%", md: "35%" } }}>
            <img
              src={androidSeven}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>

          {/* Right: Text */}
          <Grid item sx={{ width: { xs: "100%", md: "60%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Comprehensive Android Training
            </Typography>
            <Typography variant="body1">
              Our curriculum is designed to take you from a complete beginner to
              a confident Android developer capable of building real-world
              applications. We start with the fundamentals of mobile app
              development, including setting up Android Studio, understanding
              the Android lifecycle, and mastering UI/UX design principles.
              You'll learn how to build responsive and intuitive user interfaces
              using XML and explore how to connect apps to back-end services
              using RESTful APIs and JSON. From layouts and user interactions to
              handling device compatibility and app navigation, we cover every
              essential aspect required for a strong technical foundation.
            </Typography>
            <Typography variant="body1" sx={{ mt: 1 }}>
              As you progress, the training delves into more advanced Android
              development topics such as Jetpack Compose, Room database, MVVM
              architecture, and Firebase integration for authentication,
              real-time databases, and cloud messaging. You'll also gain
              hands-on experience with tools like Git for version control and
              Android Debug Bridge (ADB) for testing. To ensure you're prepared
              for real-world scenarios, the program includes multiple capstone
              projects, mock interviews, and code reviews by industry experts.
              Our goal is to make you job-ready with skills that match current
              industry demands.
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            mt: { xs: 0, md: 5 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",

                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Highly Qualified Android Training Team
            </Typography>
            <Typography variant="body1">
              Our trainers come with years of industry experience and have built
              successful apps for various domains. They are passionate mentors
              who provide one-on-one guidance, code reviews, and career advice
              throughout the training journey.
            </Typography>
            <Typography variant="body1" sx={{ mt: 1 }}>
              We provide fully-equipped training labs where you can practice app
              development in a real-time environment. These labs are designed to
              mimic professional workspaces, giving you a head start in adapting
              to industry standards.
            </Typography>
            <Typography variant="body1" sx={{ mt: 1 }}>
              Upon successful completion of the course, we connect you with
              full-time job opportunities. Our placement support includes resume
              preparation, mock interviews, and direct referrals to hiring
              companies in need of skilled Android developers.
            </Typography>
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={training}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </Box>
  );
};

export default AndroidTraining;
